<script>
import {
  ArrowUpIcon,
  MonitorIcon,
  HeartIcon,
  EyeIcon,
  BoldIcon,
  FeatherIcon,
  CodeIcon,
  UserCheckIcon,
  GitMergeIcon,
  SettingsIcon,
  VideoIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";
import countTo from "vue-count-to";

import { Carousel, Slide } from "vue-carousel";

import LoginModal from "@/components/login-modal";
import Navbar from "@/components/navbar";
import Testimonial from "@/components/testimonial";
import Pricing from "@/components/pricing2";
import Footer from "@/components/footer";
import {post} from "@/assets/js/utils";
import config from "@/config.json";

/**
 * Index-marketing component
 */
export default {
  data() {
    return {
      selected: 0,
      lang: this.getLang()
    };
  },
  methods: {
  },
  components: {
    Navbar,
    Testimonial,
    Carousel,
    Slide,
    Pricing,
    Footer,
    ArrowUpIcon,
    MonitorIcon,
    HeartIcon,
    EyeIcon,
    BoldIcon,
    FeatherIcon,
    CodeIcon,
    UserCheckIcon,
    VideoIcon,
    GitMergeIcon,
    SettingsIcon,
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
    countTo,
    LoginModal,
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section
      class="bg-marketing d-table w-100"
      style="background: url('images/marketing/marketing-shape.png')"
      id="home"
    >
      <div class="container">
        <div class="row justify-content-center mt-5">
          <div class="col-lg-7 col-md-7 text-center">
            <!--
            <img
              src="images/illustrator/Purchase-intention-3.jpeg"
              class="img-fluid"
              style="max-height: 400px"
              alt=""
            />
            -->
            <div class="title-heading mt-0 mt-md-5 mt-4 mt-sm-0 pt-2 pt-sm-0">
              <h1 class="heading mb-3">
                {{$t('buy.title')}}
              </h1>
              <p class="para-desc">
                {{$t('buy.description')}}
              </p>
              <!--
              <div class="alert alert-blue mb-0 text-left" role="alert" v-if="lang === 'zh'">
                <h4 class="alert-heading"> <i class="uil uil-info-circle"></i> {{$t('buy.member_tip_title')}}</h4>
                <p v-html="$t('buy.member_tip')"> </p>
              </div>
              -->

            </div>
          </div>
        </div>
        <!--end row-->
      </div>
      <!--end container-->

      <div class="container mt-5">
        <Pricing :pricing-data="$t('index.price.plans')" :type="1" />
      </div>

    </section>
    <!--end section-->
    <!-- Hero End -->


    <Footer />

    <!-- Footer End -->
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
